// extracted by mini-css-extract-plugin
module.exports = {"root":"ModifySelectedRooms_root__1KLN2","closeButton":"ModifySelectedRooms_closeButton__EsI2A"};